'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagNpAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.66739e-05 -1.52588e-05L27.9951 -1.0103e-05C28.0318 6.6657 28 20 28 20L2.00007 20C0.895497 20 0 20 0 20C2.42475e-05 13.3333 -6.75452e-06 6.66665 7.66739e-05 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.66739e-05 -1.52588e-05L2.46488 -1.39177e-05C2.5965 -1.39176e-05 2.72517 0.0389448 2.83468 0.111953L15.0026 8.22392C16.1003 8.95569 15.5822 10.6667 14.263 10.6667H8.00007L15.9961 17.6632C16.9227 18.4739 16.3493 20 15.1181 20H2.00007C0.895497 20 0 20 0 20C2.42475e-05 13.3333 -6.75452e-06 6.66665 7.66739e-05 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.66739e-05 -1.52588e-05L2.46488 -1.39177e-05C2.5965 -1.39176e-05 2.72517 0.0389448 2.83468 0.111953L15.0026 8.22392C16.1003 8.95569 15.5822 10.6667 14.263 10.6667H8.00007L15.9961 17.6632C16.9227 18.4739 16.3493 20 15.1181 20H0L7.66739e-05 -1.52588e-05Z",
          fill: "#EE1B44"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.263 10.6667C15.5822 10.6667 16.1003 8.95569 15.0026 8.22392L2.83468 0.111953C2.72517 0.0389448 2.5965 -1.39176e-05 2.46488 -1.39177e-05L7.66739e-05 -1.52588e-05L0 20H15.1181C16.3493 20 16.9227 18.4739 15.9961 17.6632L8.00007 10.6667H14.263ZM1.3334 18.6667H15.1181L7.12206 11.6701C6.70402 11.3043 6.55655 10.7177 6.75193 10.1977C6.9473 9.6777 7.44459 9.33332 8.00007 9.33332H14.263L2.26303 1.33332H1.3334V18.6667Z",
          fill: "#0543A8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.85115 7.80075C7.23526 7.69549 7.58938 7.55152 7.90258 7.37613C7.59193 8.5045 6.55841 9.33332 5.33132 9.33332C4.10423 9.33332 3.07072 8.5045 2.76007 7.37613C3.07413 7.552 3.42934 7.69628 3.81468 7.80163L4.3334 7.33332L3.48564 6.56795L4.62629 6.62621L4.56803 5.48556L5.3334 6.33332L6.09876 5.48556L6.0405 6.62621L7.18116 6.56795L6.3334 7.33332L6.85115 7.80075Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.31303 17.1303L5.33352 16L6.35401 17.1303L6.27632 15.6095L7.7972 15.6871L6.66685 14.6667L7.7972 13.6462L6.27632 13.7238L6.35401 12.203L5.33352 13.3333L4.31303 12.203L4.39071 13.7238L2.86984 13.6462L4.00018 14.6667L2.86984 15.6871L4.39071 15.6095L4.31303 17.1303Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.52196 -4.78315e-06H28L27.5099 0.499995H3.42274L2.52196 -4.78315e-06Z",
          fill: "#949494"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.166 19.5H27.5005L28 20C28 20 14.5311 20 15.1645 20C15.7979 20 16.166 19.5 16.166 19.5Z",
          fill: "#949494"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.5 19.5025V0.511575L28 -4.78315e-06L28 20L27.5 19.5025Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagNpAsset = forwardRef(FlagNpAsset);

export { VpFlagNpAsset as default };
